import useDynamicComponentBuilderStore from "%/stores/dynamic-component-builder-store";
import { useConfigurationPanelStore } from "~/stores/configuration-panel-store";
import { mapActions, mapState, mapWritableState } from "pinia";
import { ElementResizingMixinStaging } from "%/dynamic-components/builder-engine/mixins/element-resizing-mixin-staging";

const CanvasEventHandlerMixinStaging = {
  data() {
    return {
      mouseOver: false,
      mouseOverActions: false,
      lastClickedAtMilliseconds: 0,
    };
  },
  mixins: [ElementResizingMixinStaging],
  computed: {
    ...mapWritableState(useConfigurationPanelStore, [
      "newDynamicComponentLayout",
    ]),
    ...mapWritableState(useDynamicComponentBuilderStore, [
      "detachingElementIdentifier",
    ]),
    ...mapState(useDynamicComponentBuilderStore, [
      "showContextualMenuForIdInBuilder",
    ]),
  },
  methods: {
    ...mapActions(useDynamicComponentBuilderStore, [
      "handleOnEdit",
      "handleOnEditParent",
      "handleDuplicate",
      "handleOnDelete",
      "setElementToFocusOnHover",
      "setShowContextualMenuForIdInBuilder",
      "wrapElementInContainer",
      "wrapSelectionInContainer",
      "getLayoutOfElementByIdentifier",
      "isEditable",
      "handleDetach",
      "canWrapCurrentSelection",
    ]),
    internalMouseOverHandler() {
      this.mouseOver = true;
      this.setElementToFocusOnHover(this.identifier);
    },
    internalMouseLeaveHandler() {
      if (this.resizing) {
        return false;
      }
      this.mouseOver = false;
      this.setElementToFocusOnHover(null);
    },
    internalHandleOnEdit(event) {
      if (sessionStorage.getItem("resizing")) {
        return false;
      }
      // simulate a mousedown event to trigger the click outside directive
      if (this.editMode) {
        const mousedownEvent = new MouseEvent("mousedown", {
          bubbles: true,
          cancelable: true,
          view: window,
        });
        const mouseupEvent = new MouseEvent("mouseup", {
          bubbles: true,
          cancelable: true,
          view: window,
        });

        document.querySelector("body").dispatchEvent(mousedownEvent);
        document.querySelector("body").dispatchEvent(mouseupEvent);
      }

      this.setShowContextualMenuForIdInBuilder(null);
      const millisecondsSinceLastClick = new Date().getTime() - this.lastClickedAtMilliseconds;
      if (millisecondsSinceLastClick < 300) {
        this.handleOnEditParent(this.identifier);
      } else {
        this.lastClickedAtMilliseconds = new Date().getTime();
        if (this.isEditable) {
          this.handleOnEdit(this.identifier, event);
        }
      }
      this.lastClickedAtMilliseconds = new Date().getTime();
      useDynamicComponentBuilderStore().setActiveBreakpointByAlias(this.breakpoint);
    },
    internalHandleDuplicate() {
      if (this.breakpoint) {
        return;
      }
      this.handleDuplicate(this.identifier);
    },
    internalHandleOnDelete() {
      if (this.breakpoint) {
        return;
      }
      this.handleOnDelete(this.identifier);
    },
    internalCreateCustomComponent() {
      this.newDynamicComponentLayout = this.getLayoutOfElementByIdentifier(this.identifier);
      const name = useDynamicComponentBuilderStore().generateComponentName();
      useConfigurationPanelStore().createDynamicComponentWithoutTemplate(name, {}, id => {
        window.location.href = `${useConfigurationPanelStore().webLink}/dynamic-component/${id}`;
      });
    },
    internalWrapInHorizontalContainer() {
      if (this.breakpoint) {
        return;
      }
      this.wrapElementInContainer("HorizontalContainerWrapper", this.identifier);
    },
    internalWrapInVerticalContainer() {
      if (this.breakpoint) {
        return;
      }
      this.wrapElementInContainer("VerticalContainerWrapper", this.identifier);
    },
    internalWrapSelectionInVerticalContainer() {
      if (this.breakpoint) {
        return;
      }
      this.wrapSelectionInContainer("VerticalContainerWrapper", this.currentlyInspectedElementIdentifiers);
    },
    internalWrapSelectionInHorizontalContainer() {
      if (this.breakpoint) {
        return;
      }
      this.wrapSelectionInContainer("HorizontalContainerWrapper", this.currentlyInspectedElementIdentifiers);
    },
    internalCreateDynamicComponentFromIdentifier() {
      useConfigurationPanelStore().createDynamicComponentFromIdentifier(this.identifier);
    },
    internalHandleCopy() {
      useDynamicComponentBuilderStore().handleClipboardPublicationElementTransfer(this.dynamicComponentInstance.getElementById(this.identifier), "copy");
    },
    internalHandlePaste() {
      useDynamicComponentBuilderStore().handleClipboardPublicationElementPaste();
    },
    internalHandleDetach() {
      this.detachingElementIdentifier = this.identifier;
    },
  },
};

export { CanvasEventHandlerMixinStaging };
